import { connect } from 'react-redux';
import { fetchFontsIfNeeded, sign } from 'common/ducks/contract';
import SignContract from 'common/components/modal/sign_contract';

const mapStateToProps = ({contract: {fonts, isSigning, error}}) => ({
  fonts,
  isSigning,
  error
})

export default connect(mapStateToProps, {
  fetchFontsIfNeeded,
  sign
})(SignContract);



// WEBPACK FOOTER //
// ./common/containers/sign_contract.jsx